import "@/App.css";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Projects } from "@/components/Projects";
import { Achievements } from "@/components/Achievements";
import { Skills } from "@/components/Skills";
import { Contact } from "@/components/Contact";

function App() {
  useLenis();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="bottom-center" richColors />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Projects />
        <Achievements />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}

export default App;
